<app-navbar></app-navbar>
    <div class="container mt-4">
        <div class="col-lg-12">
            <h1 class="fw-semibold display-6">Products</h1>
            <div class="inter text-muted">All our products have undergone evaluation and are approved and license accredited by the Philippine Food and Drug Administration, ensuring they are safe and of high quality.</div>
        </div>
    </div>
    <div class="container mt-4">
        @if(nutraceutics().length > 0){
            <div class="row">
                <div class="col-lg-12">
                    <h3 class="fs-5">Nutraceutics</h3>
                </div>
            </div>
        }
        <div class="row">
            @if(isLoading()){
                @for (item of [].constructor(12); track $index) {
                    <div class="col-lg-3">
                        <ngx-skeleton-loader count="1" appearance="line" [theme]="{ 'height': '430px', 'margin-bottom': '20px', 'width': '100%', 'border-radius': '7px' }"></ngx-skeleton-loader>
                    </div>
                }
            }
            @for (obj of nutraceutics(); track obj.slug) {
                <div class="col-lg-3" animate.enter="fadein" animate.leave="fadeout">
                    <a [routerLink]="['/product', obj.slug]" class="text-decoration-none">
                        <div class="products inter mb-4 rounded-3">
                            <div class="img rounded-2 m-3">
                                <span class="position-absolute border border-dark bg-light rounded-5 px-2 py-1 fs-6 inter cat mt-2 ms-2 fs-7">{{obj.category | titlecase}}</span>
                                <img [src]="obj.thumbnail" [alt]="obj.item" class="object-fit-contain w-100 h-100 rounded-3">
                            </div>
                            <div class="px-3">
                                <div class="fs-6 fw-medium text-dark">{{obj.item | truncate: 30}}</div>
                                <div class="text-muted fs-7">{{obj.unit | titlecase}}</div>
                                <div class="fs-6 mt-3 mb-3 text-muted" [title]="obj.summary">{{obj.summary | truncate: 60}}</div>
                                @if(obj.price) {
                                    <div class="fw-semibold fs-6 text-dark">{{obj.price | currency:'PHP':'symbol'}} </div>
                                }
                            </div>
                        </div>
                    </a>
                </div>
            }
        </div>
    </div>
    <div class="container mt-4 mb-4">
        @if(pharmaceutics().length > 0){
            <div class="row">
                <div class="col-lg-12">
                    <h3 class="fs-5">Pharmaceutics</h3>
                </div>
            </div>
        }
        <div class="row">
            @for (obj of pharmaceutics(); track obj.slug) {
                <div class="col-lg-3">
                    <a class="text-decoration-none">
                        <div class="products inter mb-4 rounded-3">
                            <div class="img rounded-2 m-3">
                                <span class="position-absolute border border-dark bg-light rounded-5 px-2 py-1 fs-6 inter cat mt-2 ms-2 fs-7">{{obj.category | titlecase}}</span>
                                <img [src]="obj.thumbnail" class="object-fit-contain w-100 h-100 rounded-3">
                            </div>
                            <div class="px-3">
                                <div class="fs-6 fw-medium text-dark">{{obj.item}}</div>
                                <div class="text-muted fs-7">{{obj.unit | titlecase}}</div>
                                <div class="fs-6 mt-3 mb-3 text-muted" [title]="obj.summary">{{obj.summary | truncate: 60}}</div>
                                @if(obj.price) {
                                    <div class="fw-semibold fs-6 text-dark">{{obj.price | currency:'PHP':'symbol'}} </div>
                                }
                            </div>
                        </div>
                    </a>
                </div>
            }
        </div>
    </div>
<app-footer></app-footer>